import React, { useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
// import { RoutePath } from '../../../routes/Routes';
import StateComponents from '../../../../components/state-component/StateComponents';
import { useNavigate, useParams } from 'react-router-dom';
import ModalMedia from '../../media/modal-media/ModalMedia';
import { linkPreviewImage } from '../../../../components/upload-image-preview/UploadImagePreview';
// import { STATUS_ENUM } from '../../manage-articles/enum/article.enum';
import ContainerButton from '../../../../components/button/ContainerButton';
import { ManageStateDetail } from './manageStateDetail';
import BannerTypeContent from './element/BannerTypeContent';
import { IconComponents } from '../../../../assets/icons/icons';
import { alertActive } from '../../../../components/alert/swal';
import { STATUS_ENUM } from './enum/content.enum';
import { Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { routeName } from '../../../../routes/routeName';

type Props = {
    view: boolean;
}

const ContentStructureDetail: React.FC<Props> = ({ view }: Props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [is_copy, set_is_copy] = useState<boolean>(false);

    const {
        formState,
        handleChangeFormState,
        handleSubmit,
        errorMessage,
        id_media_file,
        set_file_api_url,
        set_id_media_file,
        showModal,
        setFormState,
        handleCloseModal,
        image_api,
        handleChangeImageApi,
        setShowModal,
        handleDeleteImageApi,
        content_no
    } = ManageStateDetail();

    // console.log(image_api,'image_api')
    return (
        <ContainerLayout
            title=''
            titleName={id ? 'จัดการเนื้อหา' : 'เพิ่มเนื้อหา'}
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "โครงสร้างเว็บไซต์",
                                name: "โครงสร้างเว็บไซต์",
                                disabled_match: true,
                                pathName: ""
                            },
                            {
                                key: "จัดการเนื้อหา",
                                name: "จัดการเนื้อหา",
                                pathName: routeName.cms_website.website_structure_content
                            },
                            ...((id && view) ? [
                                {
                                    key: "manage_articles_view",
                                    name: "รายละเอียดเนื้อหา",
                                    pathName: routeName.cms_website.website_structure_content_view.replace(":id", id),
                                },
                            ] : (id && !view) ? [
                                {
                                    key: "manage_journals_detail",
                                    name: "รายละเอียดเนื้อหา",
                                    pathName: routeName.cms_website.website_structure_content_detail.replace(":id", id),
                                },
                            ] : [
                                {
                                    key: "website_structure_content_create",
                                    name: "เพิ่มเนื้อหา",
                                    pathName: routeName.cms_website.website_structure_content_create,
                                },
                            ])
                        ]}
                />
            }

            buttonContent={
                <div className='w-full flex justify-end items-center gap-2'>
                    <StateComponents
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12
                                },
                                hidden: formState.status === STATUS_ENUM.DRAFT || !id,
                                type: "TEXT_FIELD",
                                fieldProps: {
                                    value: content_no,
                                    placeholder: 'ลิ้งเชื่อมโยง',
                                    endAdornment: <Button sx={{
                                        width: is_copy ? 240 : 150,
                                        opacity: is_copy ? .4 : 1,
                                        textTransform: 'none',
                                        transition: 'all .1s ease'
                                    }} variant='contained' startIcon={<ContentCopyIcon />} onClick={() => {
                                        set_is_copy(true);
                                        navigator.clipboard.writeText(content_no).then(() => {
                                            setTimeout(() => {
                                                set_is_copy(false)
                                            }, 1000)
                                        });
                                    }}>{is_copy ? 'loading..' : 'คัดลอก'}</Button>,
                                    onChange: () => { }
                                }
                            }
                        ]}
                    />
                    <ContainerButton
                        justifyContent='flex-end'
                        sxContainer={{ maxWidth: "fit-content" }}
                        buttonData={[
                            {
                                key: "BACK",
                                buttonProps: {
                                    onClick: () => navigate(-1)
                                },
                                label: "ย้อนกลับ",
                                seq: 1,
                                type: "BACK"
                            },
                            // {
                            //     key: "SAVE_DRAFT",
                            //     hidden: view || formState.status === STATUS_ENUM.ACTIVE,
                            //     buttonProps: {
                            //         onClick: () => handleSubmit("DRAFT")
                            //     },
                            //     label: "บันทึกร่าง",
                            //     seq: 2,
                            //     type: "SAVE_DRAFT"
                            // },
                            {
                                key: "SAVE",
                                hidden: view,
                                buttonProps: {
                                    onClick: () => {
                                        alertActive("บันทึกข้อมูล", "ท่านต้องการบันทึกข้อมูลเนื้อหา?", "บันทึก", "ยกเลิก", () => {
                                            handleSubmit("SUBMIT")
                                        })
                                    }
                                },
                                label: "บันทึก",
                                seq: 3,
                                type: "SAVE"
                            },
                        ]}
                    />
                </div>
            }
            content={
                <div className='w-full'>
                    <StateComponents
                        disabledAllField={view}
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "SWITCH",
                                gridProps: {
                                    xs: 12
                                },
                                fieldProps: {
                                    disabled: view,
                                    checked: formState.is_public ? true : false,
                                    onChange: (val) => handleChangeFormState('is_public', val ? 1 : 0),
                                    label: "สถานะการเผยแพร่"
                                }
                            },
                            {
                                seq: 2,
                                type: "DATE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    helperText: errorMessage.content_start_date,
                                    required: true,
                                    onChange: (date) => handleChangeFormState('content_start_date', date),
                                    value: formState.content_start_date,
                                    heading: "วันที่เริ่มต้นเผยแพร่",
                                    placeholder: "ระบุ"
                                }
                            },
                            {
                                seq: 3,
                                type: "DATE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    helperText: errorMessage.content_end_date,
                                    required: true,
                                    disabled: view || !formState.content_start_date,
                                    disableStartDate: formState.content_start_date,
                                    onChange: (date) => handleChangeFormState('content_end_date', date),
                                    value: formState.content_end_date,
                                    heading: "วันที่สิ้นสุดเผยแพร่",
                                    placeholder: "ระบุ"
                                }
                            },
                            {
                                seq: 4,
                                type: "TIME_PICKER",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    helperText: errorMessage.content_start_time,
                                    required: true,
                                    value: formState.content_start_time,
                                    onChange: (e) => handleChangeFormState('content_start_time', e),
                                    heading: "เวลาที่เริ่มต้นเผยแพร่",
                                    placeholder: "ระบุ"
                                }
                            },
                            {
                                seq: 5,
                                type: "TIME_PICKER",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    helperText: errorMessage.content_end_time,
                                    required: true,
                                    value: formState.content_end_time,
                                    onChange: (e) => {
                                        handleChangeFormState('content_end_time', e)
                                    },
                                    heading: "เวลาที่สิ้นสุดเผยแพร่",
                                    placeholder: "ระบุ"
                                }
                            },
                        ]}
                    />
                    <div className='w-full my-10'>
                        <BannerTypeContent
                            value={formState.banner_type}
                            disabled={view}
                            onClick={(val) => !view && handleChangeFormState('banner_type', val)}
                        />
                    </div>
                    <div className='w-full shadow-md py-4 my-10'>
                        <StateComponents
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "MULTI_UPLOAD_IMAGE",
                                    gridProps: {
                                        xs: 12
                                    },
                                    fieldProps: {
                                        handleDeleteImageApi: (_, i) => handleDeleteImageApi(i),
                                        handleDeleteImageSelect: () => { },
                                        onChange: () => { },
                                        tabIndex: 2,
                                        valueAddFile: [],
                                        heading: 'ไฟล์แกลเลอรี',
                                        onUploadMedia: () => {
                                            setShowModal("ADD")
                                        },
                                        is_using_modal_media: true,
                                        disabled: view,
                                        addImageIcon: <IconComponents.UploadImageFileIcon />,
                                        valueImage: image_api || []
                                    }
                                },
                            ]}
                        />
                    </div>
                    <div className='w-full grid grid-cols-12 gap-4 mt-6'>
                        <span className='col-span-12'>
                            <StateComponents
                                otherProps={{ spacing: 3 }}
                                disabledAllField={view}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            disabled: view,
                                            // required: true,
                                            // helperText: errorMessage.content_name,
                                            heading: 'ชื่อ',
                                            placeholder: 'ระบุ',
                                            value: formState.content_name,
                                            onChange: (e) => handleChangeFormState('content_name', e.target.value)
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            disabled: view,
                                            heading: 'ข้อความย่อย',
                                            placeholder: 'ระบุ',
                                            value: formState.content_desc,
                                            onChange: (e) => handleChangeFormState('content_desc', e.target.value)
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "TEXT-EDITOR",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            disabled: view,
                                            heading: 'รายละเอียด',
                                            placeholder: 'ระบุ',
                                            textString: formState.content_detail,
                                            onChange: (e) => {
                                                handleChangeFormState('content_detail', e);
                                            }
                                        }
                                    },
                                ]}
                            />
                        </span>
                    </div>

                    {showModal !== "" && (
                        <ModalMedia
                            open
                            handleClose={handleCloseModal}
                            title='เพิ่มไฟล์'
                            id_media_file={id_media_file}
                            multiple
                            onSelectMediaFile={(_, id) => set_id_media_file(id)}
                            onSubmitMediaFile={async (_, id_media_file) => {
                                handleCloseModal();
                                const path = await linkPreviewImage(id_media_file);
                                set_file_api_url(path);
                                setFormState((prev) => ({ ...prev, id_media_file }))
                                // handleSubmit(id_media_file);
                            }}
                            onSubmitMediaFileMultiple={(media_file) => {
                                handleChangeImageApi(media_file)

                            }}
                            onSubmitLocalFile={async (id_media_file) => {
                                const path = await linkPreviewImage(id_media_file);
                                setFormState((prev) => ({ ...prev, id_media_file }))
                                set_file_api_url(path);
                                handleCloseModal();
                                // handleSubmit(id_media_file);
                            }}
                        />
                    )}
                </div>
            }
        />
    )
}

export default ContentStructureDetail